module.exports = __webpack_public_path__ + "static/media/chevron-down.c1a496dd.svg";